import * as mongoose from 'mongoose'

import { Image, StoreCategoryRelation, ChannelLocation } from 'common/types/entities/mongo/sub'
import { StoreZzim } from 'common/types/entities/store'
import { getSubVerticalPath, SubVertical, Vertical } from 'common/constants/verticalService'
import { ImageClass, InspectionStatus } from 'common/constants'
import { ChannelSaleTime } from '../api/channel'
import { BrandIndexType } from 'common/constants/brand'
import BrandInitialIndexType from 'common/constants/brand/initialIndexType'

export interface Channel extends mongoose.Document {
  _id: string
  name: string
  vertical: Vertical
  subVertical: SubVertical
  inspectionStatus: InspectionStatus
  storeCategory: string[]
  representativeImage?: Image
  logoImage?: Image
  additionalImages?: Image[]
  talkAccountId?: string
  talkExposedYn?: boolean
  descriptionContents?: string
  detailIntroductionContents?: string
  salesTime?: ChannelSaleTime
  bestShopYn?: boolean
  inspectionBypassYn?: boolean
  inquiryUseYn?: boolean
  alias?: string
  handleBrandNames?: string[]
  storeNaverMapUrl?: string
  storeNaverMapMobileUrl?: string
  communicationSalesNo?: string
  testChannelYn?: boolean
  createdAt?: Date
  updatedAt?: Date
  storeCategoryRelations?: StoreCategoryRelation[]
  location?: ChannelLocation
  recentlyUpdatedProductCount?: number
  representBrands?: {
    _id: string
    name: string
    logoImage?: string // from redis
  }[]
  initialWords: string[]
  initialTypes: BrandIndexType[]
  initialIndexTypes: BrandInitialIndexType[]
  hasHighRatingReview: boolean
}

export interface ExtendedChannel extends Channel {
  zzim?: StoreZzim
  view?: number
}

export const getStoreUrl = (channel: Channel): string => {
  if (!channel) {
    return null
  }
  return `${getSubVerticalPath(getSubVertical(channel))}/stores/${channel._id}`
}

export const getSubVertical = (channel: Channel): SubVertical => {
  if (!channel) {
    return null
  }
  return channel && channel.storeCategoryRelations && channel.storeCategoryRelations[0].subVertical
}

export const getImage = (channel: Channel, type: ImageClass): Image => {
  if (!channel || !type) return
  return (
    channel.additionalImages &&
    channel.additionalImages.length > 0 &&
    channel.additionalImages.find(image => image.imageClassType === type)
  )
}

export const getStoreCategoryRelation = (channel: Channel, subVertical: SubVertical) => {
  return channel.storeCategoryRelations && channel.storeCategoryRelations.find(rel => rel.subVertical === subVertical)
}
